import { Typography } from "antd";
import { CloudUploadOutlined, LockOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { useDragDrop } from "@/hooks";
import { DOCUMENT_AUTO_DELETE_DAYS } from "@/utils/constants";

const { Text, Title } = Typography;

interface UploadZoneProps {
  onFilesDropped: (files: FileList) => void;
  children: React.ReactNode;
}

export default function UploadZone({ onFilesDropped, children }: UploadZoneProps) {
  const { isDragging, handlers } = useDragDrop(onFilesDropped);

  return (
    <div
      style={{ position: "relative", minHeight: "100%" }}
      {...handlers}
    >
      {children}

      {isDragging && (
        <div
          className="drag-overlay"
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(15, 110, 86, 0.05)",
            border: "2px dashed #0F6E56",
            borderRadius: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 100,
            backdropFilter: "blur(2px)",
          }}
        >
          <CloudUploadOutlined
            style={{ fontSize: 64, color: "#0F6E56", marginBottom: 16 }}
          />
          <Title level={4} style={{ color: "#0F6E56", marginBottom: 8 }}>
            Drop files here to upload
          </Title>
          <Text type="secondary" style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <LockOutlined /> Files will be encrypted and stored securely
          </Text>
          <Text
            type="secondary"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              marginTop: 8,
              fontSize: 12,
              color: "#6B7280",
            }}
          >
            <ClockCircleOutlined /> Documents auto-delete after {DOCUMENT_AUTO_DELETE_DAYS} days
          </Text>
        </div>
      )}
    </div>
  );
}
